import { useShallow } from 'zustand/shallow';
import { useDownloadsStore } from '../../global-state/downloads';
import { useUserDataStore } from '../../global-state/user-data';
import { Episode } from '../../models/podcasts';
import { iconBlue } from '../../utils/colors';
import { trackDownloadClick } from '../../utils/plausible-events';
import ProgressCircle from '../progress-circle';
import style from './style.module.css';

const DownloadButton = ({ episode }: { episode: Episode }) => {
  const [downloadEpisode, removeDownload, downloadProgress] = useDownloadsStore(
    useShallow((s) => [
      s.downloadEpisode,
      s.removeDownload,
      s.downloadsProgress[episode.id],
    ])
  );
  const isQueuedForDownload = useUserDataStore((s) =>
    s.downloadedEpisodeIds.includes(episode.id)
  );
  const progress = isQueuedForDownload && downloadProgress ? downloadProgress[0] : 0;

  return (
    <button
      class="button button--download"
      onClick={() => {
        if (isQueuedForDownload) {
          removeDownload(episode.id);
        } else {
          downloadEpisode(episode);
          trackDownloadClick(episode);
        }
      }}
      style={{ background: progress === 1 ? iconBlue : 'white' }}
      title={isQueuedForDownload ? 'Remove from downloads' : 'Download'}
    >
      <ProgressCircle
        percent={progress || 0}
        size={'2rem'}
        borderWidth={'3px'}
        color={iconBlue}
        shouldEase={isQueuedForDownload}
      />
      <span class={style.text}>
        {isQueuedForDownload && progress > 0 && progress < 1 ? (
          <>
            {Math.round(progress * 100)}
            {progress < 0.095 ? <small class={style.small}>%</small> : ''}
          </>
        ) : (
          <svg
            viewBox="100 100 312 312"
            style={{
              height: '1.5rem',
              width: '1.5rem',
              marginTop: '-2px',
              fill:
                progress === 1
                  ? 'white'
                  : isQueuedForDownload
                    ? 'currentColor'
                    : 'black',
            }}
            class={isQueuedForDownload && !progress ? 'pulse' : ''}
          >
            <path d="m256 409.7-104-104 21.5-21.4 67.3 67.3V154h30.4v197.6l67.3-67.3 21.5 21.4Z" />
          </svg>
        )}
      </span>
    </button>
  );
};

export default DownloadButton;
